const getAdOpsCampaignPaginatedQueryOptionsFromTableSettings = (
  tableSettings
) => {
  // Get paginated query options : filters, sorting and pagination
  const { globalFilter, columnFilters, sorting, pagination } = tableSettings;
  // Filters
  const filterText = globalFilter;
  const filterHasNoLineItem = columnFilters?.find((cf) => cf.id === "hasNoLineItem")
  ? columnFilters?.find((cf) => cf.id === "hasNoLineItem").value
  : null;

  const filterDeleted =
    columnFilters?.find((cf) => cf.id === "active")?.value === false;

  // Sorting
  const sortBy = `${sorting[0].id}-${sorting[0].desc ? "desc" : "asc"}`;
  // Pagination
  const page = pagination.pageIndex + 1;
  const nbDocsPerPage = pagination.pageSize;

  const queryOptions = {
    filterText,
    filterHasNoLineItem,
    filterDeleted,
    sortBy,
    page,
    nbDocsPerPage,
  };

  return queryOptions;
};

export default getAdOpsCampaignPaginatedQueryOptionsFromTableSettings;
